










import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "BaseListItem" })
export default class BaseListItem extends Vue {}
